import Rollbar from 'rollbar';
import { LoggerUsingRollbar, LoggerUsingConsole } from 'rollbar-logger';

const rollbarToken = window.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;
const environment = window.env.REACT_APP_NODE_ENV;
const isDevEnvironment = environment === 'development';

const createLogger = () => {
  if (rollbarToken && !isDevEnvironment) {
    const rollbar = new Rollbar({
      accessToken: rollbarToken,
      environment,
      captureUncaught: false,
      captureUnhandledRejections: false,
    });
    return new LoggerUsingRollbar(rollbar);
  }
  return new LoggerUsingConsole();
};

const logger = createLogger();

export default logger;
